import LinkAccountContent from './LinkAccountContent'

export default LinkAccountContent
